import { z } from "zod";

/**
 * A reference to a media item stored in offline DB / backend.
 * Holds the client-generated id (UUID) used as the media's primary key.
 */
export const mediaRefSchema = z.string().min(1);
export type MediaRef = z.infer<typeof mediaRefSchema>;

/** Multi-photo slot (e.g. clientWorks.requests). */
export const mediaListSchema = z.array(mediaRefSchema).default([]);

/** GPS point captured at signature / photo time. */
export const gpsPointSchema = z.object({
  latitude: z.number(),
  longitude: z.number(),
  accuracy: z.number().nullable().optional(),
  capturedAt: z.string().datetime({ offset: true }).optional(),
});
export type GpsPoint = z.infer<typeof gpsPointSchema>;
